// StripeRefresh.jsx : si l’utilisateur annule
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../../../../config.json";
import { toast } from "react-toastify";

const StripeRefresh = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const retryOnboarding = async () => {
    try {
      const queryParams = new URLSearchParams(location.search);
      const restaurantId = queryParams.get("restaurantId");

      if (!restaurantId) return;

      const response = await axios.post(
        `${config.dev}/v2/restaurant/stripe/create-account/${restaurantId}`
      );

      if (response.data?.onboardingUrl) {
        toast.info("Redirecting to Stripe...");
        window.location.href = response.data.onboardingUrl;
      }
    } catch (err) {
      console.error(err);
      toast.error("Error restarting onboarding.");
    }
  };

  return (
    <div className="text-center mt-5">
      <h3>You have left the Stripe process</h3>
      <p>Please retry activation to complete.</p>
      <button className="btn btn-primary" onClick={retryOnboarding}>
        Relaunch Stripe
      </button>
    </div>
  );
};

export default StripeRefresh;
